<template>
  <div style="overflow-y: auto;padding: 0 8px;">
    <div class="bg-color h-100"
         style="height: calc(100% - 16px);margin-top: 8px;">
      <div style="padding: 20px 40px;">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane label="刷卡记录" name="logs">
            <el-row class="margin-top-10" style="height: calc(100vh - 280px)">
              <el-table
               size="mini"
                :data="doorLogs.data"
                height="100%"
                border
                class="table no-row-border"
                style="width: 100%;max-height: 100%;margin-top: 10px;overflow-y: auto">
                <el-table-column
                  align="center"
                  label="序号"
                  width="80"
                  type="index"
                  :index="changeIndex">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="卡号"
                  prop="card">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="员工名"
                  prop="name">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="工号"
                  prop="number">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="部门名称"
                  prop="section">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="记录类型"
                  prop="log">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="门名称"
                  prop="door">
                </el-table-column>
                <el-table-column
                  align="center"
                  label="开门时间"
                  width="200"
                  prop="time">
                </el-table-column>
              </el-table>
            </el-row>
            <el-row class="margin-top-30" v-if="doorLogs.count > doorLogs.max">
              <el-pagination
                :current-page.sync="doorGetSetting.data.page"
                :page-size.sync="doorLogs.max"
                :total="doorLogs.count"
                style="text-align: center;"
                @current-change="handleCurrentChange"
                layout="prev, pager, next,jumper">
              </el-pagination>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="控制器" name="control" style="height: calc(100vh - 220px)">
            <control :accessList="accessList" :selectAccess="selectAccess"
                     :areaList="areaList" :brandList="brandList"
                     ref="control"
                     @sendWebsocket="sendWebsocket"></control>
          </el-tab-pane>
          <el-tab-pane label="区域/部门" name="area" style="height: calc(100vh - 220px)">
            <area-section :areaList="areaList" :sectionList="sectionList"
                          @sendWebsocket="sendWebsocket"></area-section>
          </el-tab-pane>
          <el-tab-pane label="用户" name="user" style="height: calc(100vh - 220px)">
            <user :userList="userList" :sectionList="sectionList"
                  ref="user"
                  @userOperation="userOperation"></user>
          </el-tab-pane>
          <el-tab-pane label="控制权限" name="authorize" style="height: calc(100vh - 170px)">
            <authorize :userList="userList" :doorList="doorList"
                       ref="authorize"
                       @sendWebsocket="sendWebsocket">
            </authorize>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import User from "./User";
import Authorize from "./Authorize";
import AreaSection from "./Area";
import Control from "./Control";

export default {
  name: "Default",
  components: {User, Authorize, AreaSection, Control},
  props: ['deviceInfo'],
  data() {
    return {
      id: null,
      activeName: 'logs',
      websocket: null,
      // 获取开门记录的请求参数
      doorGetSetting: {
        command: 'getLogs',
        data: {
          page: 1,//记录分页的页数
          index: 0,
          max: 20,
        }
      },
      doorLogs: {},
      commandId: null,
      userList: [], //用户列表
      sectionList: [],//部门列表
      doorList: [], //门列表
      accessList: [], //控制器列表
      selectAccess: [],
      areaList: [],//区域列表
      brandList: [] //门禁品牌列表
    };
  },
  mounted() {
    this.initDoor()
  },
  destroyed() {
    if (this.websocket) {
      this.websocket.close()
      this.websocket = null
    }
  },
  methods: {
    initDoor() {
      this.portProperties = JSON.parse(this.deviceInfo.portProperties)
      this.initDoorWebsocket();
    },    // 初始化websocket
    initDoorWebsocket() {
      this.initData();
      if (this.websocket) {
        this.websocket.close()
        this.websocket = null
      }

      let properties = this.portProperties
      // this.websocket = new WebSocket('ws://' + window.location.host+":"+window.g.ports+"/ws/access")
      this.websocket = new WebSocket('ws://' + properties.IP + ':' + properties.PORT)
      // this.websocket = new WebSocket('ws://192.168.75.240:6060')
      // 连接成功
      this.websocket.onopen = () => {
        this.sendGetLogs() //获取刷卡记录
        this.sendGetUsers();//获取用户列表
        this.sendGetSection();//获取部门列表
        this.sendGetAccess();//获取控制器列表
        this.sendGetArea();//获取区域列表
        this.sendGetAccessBrand();//获取品牌列表
      }
      this.websocket.onerror = () => {
        console.log("ws出错");
        this.initData();
      }
      // 消息回调
      this.websocket.onmessage = (e) => {
        let websocketObj = JSON.parse(e.data)
        this[websocketObj.command](websocketObj)
      }
    },
    sendWebsocket(command, data) {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: command, data: data}))
      }
    },
    //刷卡数据消息回调
    message(data) {
      if (data.data.id !== this.commandId) {
        this.commandId = data.id
        this.sendGetLogs();
      }
    },
    // 向门禁发送获取开门记录命令
    sendGetLogs() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify(this.doorGetSetting))
      }
    },
    // 获取开门记录回调
    getLogs(data) {
      this.doorLogs = data
    },
    changeIndex(val) {
      return (this.doorGetSetting.data.page - 1) * this.doorGetSetting.data.max + val + 1
    },
    handleCurrentChange(val) {
      this.doorGetSetting.data.page = val;
      this.doorGetSetting.data.index = this.doorGetSetting.data.max * (val - 1);
      this.sendGetLogs();
    },

    //获取用户
    sendGetUsers() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: 'getUser'}))
      }
    },
    switchingDoor(data) {
      if (data.info.result === 'OK') {
        return this.$message.success("控制开门成功")
      }
    },
    getUser(data) {
      this.userList = []
      if (data.info.result === 'OK') {
        this.userList = data.users
      }
    },
    userOperation(data, operate) {
      let command;
      if (operate === 'delete') {
        command = "delUser"
      } else {
        if (data.id) {
          command = "alterUser"
        } else {
          command = "addUser"
        }
      }
      data.number = parseInt(data.number)
      data.card = parseInt(data.card)
      this.sendWebsocket(command, data)
    },
    alterUser(data) {
      if (data.info.result === 'OK') {
        this.$message.success("修改成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.$refs.user.closeDialog()
      this.sendGetUsers()
    },
    addUser(data) {
      if (data.info.result === 'OK') {
        this.$message.success("添加成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.$refs.user.closeDialog()
      this.sendGetUsers()
    },
    delUser(data) {
      if (data.info.result === 'OK') {
        this.$message.success("删除成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.sendGetUsers()
    },

    //获取部门
    sendGetSection() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: 'getSection'}))
      }
    },
    getSection(data) {
      this.sectionList = []
      if (data.info.result === 'OK') {
        this.sectionList = data.info.sections
      }
    },
    delSection(data) {
      if (data.info.result === 'OK') {
        this.$message.success("删除成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.sendGetSection()
    },
    addSection(data) {
      if (data.info.result === 'OK') {
        this.$message.success("新增成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.sendGetSection()
    },

    //获取控制器
    sendGetAccess() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: 'getAccess'}))//获取控制器
        this.websocket.send(JSON.stringify({command: 'findAccess'}))//搜索控制器
      }
    },
    getAccess(data) {
      this.accessList = []
      if (data.info.result === 'OK') {
        this.accessList = data.data
        let doorList = []
        if (this.accessList.length) {
          this.accessList.forEach(item => {
            if (item.door.length) {
              item.door.forEach(door => {
                door.devSn = item.devSn
                door.edit = false
                doorList.push(door)
              })
            }
          })
        }
        this.doorList = doorList
      }
    },
    // 获取门禁品牌
    sendGetAccessBrand() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: 'getModel'}))//获取控制器
      }
    },
    getModel(data) {
      this.brandList = []
      if (data.info.result === 'OK') {
        // this.brandList = data.info.models
        this.brandList = [
          {
            "id": 1,
            "name": '商宇'
          },
          {
            "id": 2,
            "name": '微耕'
          }
        ]
      }
    },
    findAccess(data) {
      this.selectAccess = []
      if (data.info.result === 'OK') {
        this.selectAccess = data.data
      }
    },
    alterAccess(data) {
      if (data.info.result === 'OK') {
        this.$message.success("修改成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.$refs.control.closeDialog()
      this.sendGetAccess()
    },
    addAccess(data) {
      if (data.info.result === 'OK') {
        this.$message.success("添加成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.$refs.control.closeDialog()
      this.sendGetAccess()
    },
    delAccess(data) {
      if (data.info.result === 'OK') {
        this.$message.success("删除成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.sendGetAccess()
    },
    alterDoor(data) {
      if (data.info.result === 'OK') {
        this.$message.success("修改成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.sendGetAccess()
    },
    openDoor(data) {
      if (data.info.result === 'OK') {
        this.$message.success("开门成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
    },

    //修改权限
    addAuthority(data) {
      if (data.info.result === 'OK') {
        this.$message.success("修改成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.$refs.authorize.clearSelection()
    },
    //删除权限
    delAuthority(data) {
      if (data.info.result === 'OK') {
        this.$message.success("删除成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.$refs.authorize.clearSelection()
    },

    //获取区域列表
    sendGetArea() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: 'getArea'}))
      }
    },
    getArea(data) {
      this.areaList = []
      if (data.info.result === 'OK') {
        this.areaList = data.area
      }
    },
    addArea(data) {
      if (data.info.result === 'OK') {
        this.$message.success("添加成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.$refs.control.closeDialog()
      this.sendGetArea()
    },
    delArea(data) {
      if (data.info.result === 'OK') {
        this.$message.success("删除成功!")
      } else {
        this.$message.error(data.info.failureCause)
      }
      this.sendGetArea()
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },
    initData() {
      this.doorLogs = {}
      this.commandId = null
      this.userList = []//用户列表
      this.sectionList = []//部门列表
      this.doorList = [] //门列表
      this.accessList = [] //控制器列表
      this.selectAccess = []
      this.areaList = []//区域列表
      this.brandList = []//门禁品牌列表
    },
  }
}
</script>

<style scoped>
::v-deep .el-table th.el-table__cell{
  background: rgba(41, 155, 255, .3);
  border: 1px solid rgba(41, 155, 255, .3) !important;
}
</style>
